import React, { useEffect, useState, useMemo, useCallback } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams, BrowserRouter as Router, Route, Link, useLocation } from "react-router-dom";


function AllCustomer() {
  const navigate = useNavigate();
  const { searchCustomer } = useParams();
  const [loading, setLoading] = useState(true);
  const [conSt, setConSt] = useState([]);
  const [reason, setReason] = useState('');
  const [time, setTime] = useState(0);
  const [active, setActive] = useState(false);
  const [multiSelect, setMultiSelect] = useState(true);
  const [stbCount, setStbCount] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [error, setError] = useState(null);
  const [allCustomer, setAllCustomer] = useState([]);
  const [networkName, setNetworkName] = useState([]);
  const [streetName, setStreetName] = useState([]);
  const [flatName, setFlatName] = useState([]);
  const [staffCode, setStaffCode] = useState([]);
      const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(null);
  const [showModal, setShowModal] = useState(false);
 const location = useLocation();
  const customerId = location.state?.customerId;

  const rowsPerPage = 100;
  
  const user = getCookie('user');
  const isStaff = getCookie('isStaff') === "true";
  const [formData, setFormData] = useState({ choose: "", area_code: "", street: "", flat: "", network: "", date: "", toDate: "" });
  const initialFormData = { choose: '', area_code: '', street: '', flat: '', network: '', date: '', toDate: '', };

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) { return value; }
    } return null;
  }
  useEffect(() => { if (!user) { navigate('/') } }, [user, navigate]);


  const handleSelectChange = (e) => { setReason(e.target.value) };
  // const handleActiveChange = () => { setActive(true); };
  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); };
  const handleClick = (acc_num) => { navigate(`/customerHistory/${acc_num}`); };
  const EditClick = (id) => { navigate(`/customeredit/${id}`); };

  const handleConStatus = (status, id, name) => {
    setConSt([status, id, name]); // save current status
    setShowModal(true);                // open modal after state is set
  };

  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const handleCheckboxChange = (id) => {
    setSelectedCustomers((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((num) => num !== id)
        : [...prevSelected, id]
    );


  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const unpaidCustomers = allCustomer
        .filter((customer) => customer.status === "unpaid")
        .map((customer) => customer.id);

      setSelectedCustomers(unpaidCustomers);
    } else {
      setSelectedCustomers([]);
    }
  };

const downloadCSV = () => {

  let headers = [
    "Sno","Status","Customer_Name","Acc_no","Code","STB_no","Door_no","Flat_name",
    "Street_name","Phone","Pay_Status","Plan_Amount","Paid_Amount","Paid_Date",
    "Balance_Amount","Discount_Amount","Advance_Amount","Pending_Amount",
    "Staff_Code","Network","Paid_time","Package","Added_date","Collection_Staff"
  ];

  // ✅ Add extra headers if user === srcv1
  if (user === "srcv1") {
    headers.push("Payment Mode", "Chequee Number/Remarks", "Payment For");
  }

  const csvRows = [];
  csvRows.push(headers.join(","));

  allCustomer.forEach((row) => {

    let formattedStatus = "";

    if (row.con_type) {
      formattedStatus = row.con_type;
    } 
    else if (["active", "Active"].includes(row.con_status)) {
      formattedStatus = "A";
    } 
    else if (["deactive", "Deactive"].includes(row.con_status)) {
      formattedStatus = `D - ${row.deactive_reason || ""}/${row.dactive_date || ""}`;
    } 
    else {
      formattedStatus = `${row.con_status || ""} - ${row.deactive_reason || ""}`;
    }

    let values = [
      row.id,
      formattedStatus,
      row.name,
      row.account_num,
      row.acc_num,
      row.serial_num,
      row.doorno,
      row.flat_name,
      row.street, 
      row.mobile,
      row.status,
      row.pay_amt,
      row.paid_amt,
      row.paid_date,
      row.balance_amt,
      row.discount,
      row.extra_balance_amt,
      row.pend_amt,
      row.area_code,
      row.net_name,
      row.paid_time,
      row.package,
      row.adate,
      row.col_boy
    ];

    // ✅ Add extra values if user === srcv1
    if (user === "srcv1") {
      values.push(
        row.payment_mode || "",
        row.cheque_no || row.remarks || "",
        row.payment_for || ""
      );
    }

    const safeValues = values.map(v => {
      const str = v == null ? "" : String(v).replace(/"/g, '""');
      return `"${str}"`;
    });

    csvRows.push(safeValues.join(","));
  });

  const csvString = csvRows.join("\n");

  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "customer_data.csv");
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
};

const filteredRows = allCustomer.filter((row) =>
  Object.values(row).some(value =>
    String(value).toLowerCase().includes(searchQuery.toLowerCase())
  )
);

// 2. TOTALS FROM ALL FILTERED ROWS
const totalPayAmt = filteredRows.reduce((s, r) => s + Number(r.pay_amt || 0), 0);
const totalPaidAmt = filteredRows.reduce((s, r) => s + Number(r.paid_amt || 0), 0);
const totalBalanceAmt = filteredRows.reduce((s, r) => s + Number(r.balance_amt || 0), 0);
const totalDiscountAmt = filteredRows.reduce((s, r) => s + Number(r.discount || 0), 0);
const totalAdvanceAmt = filteredRows.reduce((s, r) => s + Number(r.extra_balance_amt || 0), 0);
const totalPendingAmt = filteredRows.reduce((s, r) => s + Number(r.pend_amt || 0), 0);

// 3. PAGINATE FILTERED DATA ONLY
const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

// 4. TOTAL PAGES FOR FILTERED DATA
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

// 5. Pagination function
const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleClear = () => {
    setFormData(initialFormData);
  };
  const getConnectionLabel = (type) => {
    switch (type) {
      case "re_connection":
        return "RC";
      case "new_connection":
        return "NC";
      case "shift_connection":
        return "SC";
      default:
        return "";
    }
  };
const handleSaveChanges = async () => {
  try {
    const currentStatus = conSt[0]?.toLowerCase();

    // 🔥 decide next state clearly
    const isActivating = currentStatus === "deactive";

    // validation ONLY when deactivating
    if (!isActivating && !reason) {
      toast.error("Please select deactivation reason");
      return;
    }

    const response = await axios.post(
      "https://node.cabletvpay.in/conStatus",
      {
        user,
        conSt,
        active: isActivating,            // ✅ true = activate, false = deactivate
        reason: isActivating ? null : reason
      }
    );

   if (response.status === 200) {
  toast.success("Status Changed Successfully");

  setAllCustomer(response.data.result);
  setStbCount(response.data.result.length);

  // reset states
  setActive(false);
  setReason("");
  setConSt([]);
  setShowModal(false);

  // ✅ navigate with updated customer id
  navigate("/allCustomer/all", {
    state: { customerId: response.data.id }
  });
}

  } catch (err) {
    toast.error(err.response?.data?.message || "Error updating status");
  }
};

  const handleSubmit = useCallback(async (e) => {
    if (e) { e.preventDefault(); }
    setIsButtonDisabled(true);

    try {
      const response = await axios.post('https://node.cabletvpay.in/allCustomerSpecific', { user, formData });
      if (response.status === 200) {
        setSelectedCustomers([]);
        setStbCount(response.data.result.length);
        setAllCustomer(response.data.result);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Error fetching data");
    } finally {
      setIsButtonDisabled(false);
    }
  }, [formData, user]);

  const fetchUserData = useCallback(async () => {
    try {
      const response = await axios.post('https://node.cabletvpay.in/allCustomerGetInfo', { user, searchTerm });
      if (response.status === 200) {
        setSelectedCustomers([]);
        setNetworkName(response.data.net_name);
        setStbCount(response.data.allCustomer.length);
        setStaffCode(response.data.staffCode);
        setStreetName(response.data.streetDetails);
        setFlatName(response.data.flatDetails);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching data");
    } finally {
      setLoading(false);
    }
  }, [user]);

  function handleMultiSelect() {
    if (selectedCustomers.length > 0) {
      sessionStorage.setItem("customer", JSON.stringify(selectedCustomers));
      setTimeout(() => {
        navigate("/multiPaymentPage")
      }, 100);
    } else {
      toast.warning("oops! select a customer to payment")
    }
  }
useEffect(() => {
  if (!customerId || !user) return;

  const controller = new AbortController();

  const fetchCustomerById = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        "https://node.cabletvpay.in/getCustomerById",
        { user, id: customerId },
        { signal: controller.signal }
      );

      if (response.status === 200) {
        const customers = response.data?.allCustomer;

        // ❗ Important: validate array properly
        if (!Array.isArray(customers) || customers.length === 0) {
          setAllCustomer([]);
          setStbCount(0);
          setSelectedCustomers([]);
          toast.error("Customer not found!");
          return; // ⛔ stop here
        }

        // ✅ SUCCESS CASE
        setAllCustomer(customers);
        setStbCount(customers.length);
        setSelectedCustomers([]);
       
      }

    } catch (err) {
      if (err.name === "CanceledError") return;
      toast.error("Unable to fetch customer!");
    } finally {
      setLoading(false);
    }
  };

  fetchCustomerById();

  return () => controller.abort();
}, [customerId, user]);


  const handleSearchSubmit = async (event) => {
    if (event) event.preventDefault();
    try {
      if (searchTerm) {
        console.log("Searching for:", searchTerm);
        const response = await axios.post("https://node.cabletvpay.in/customerSearch", { user, searchTerm });
        if (response.status === 200) {
          setAllCustomer(response.data.allCustomer);
          setStbCount(response.data.allCustomer.length);
          setSelectedCustomers([]);
        }
      } else { console.log("serached empty ", searchTerm); }
    } catch (err) {
      setError(err.response?.data?.message || "Error fetching data");
    }
  };

  const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(stb.join(", ")).then(() => {
      toast.info("Text copied to clipboard!");
    }).catch((error) => {
      toast.warning("Not copied: " + error);
    });
  };
  async function handleDelete(delValue) {
    try {
      const response = await axios.post("https://node.cabletvpay.in/customerDelete", { user, delValue });
      if (response.status === 200) {
        toast.success("Customer Deleted Successfully");
        handleSubmit();
      }
    } catch (error) {
      setError(error.response?.data?.message || "Error fetching data");
    }
  }

  useEffect(() => {
    fetchUserData();
    if (searchCustomer !== "all" && time === 0) {
      setSearchTerm(searchCustomer);
      const timeoutId = setTimeout(() => { setTime(1); handleSearchSubmit(); console.log("Triggered once!"); }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [fetchUserData]);

  if (loading) {
    return (<div className="content-wrapper">  <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>  <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />  </div>  </div>);
  }

  if (error) {
    return (<div className="content-wrapper"> <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>  <img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />  </div>  </div>);
  }
  return (
    <div className="content-wrapper" ><div className="container_fluid">
      <div className="content-header pt-1">
        <h5 className='h5'>All CUSTOMER DETAILS</h5><hr className='mt-0' /> <div style={{ position: 'absolute', top: '30px' }}>
          <ToastContainer theme='dark' />
        </div>
     {showModal && (
  <div className="modal fade show" style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header bg-gradient-navy">
          <h5 className="modal-title">
            Do You Wish To Change Connection Status ?
          </h5>
          <button
            type="button"
            className="close text-light"
            onClick={() => setShowModal(false)}
          >
            <span>&times;</span>
          </button>
        </div>

<div className="modal-body">
  <b>
    {conSt[2]}{" "}

    {conSt[0]?.toLowerCase() === "active" ? (
      <select
        value={reason}
        onChange={handleSelectChange}
      >
        <option value="">none</option>
        <option value="T/D/C">T/D/C</option>
        <option value="P/D/C">P/D/C</option>
        <option value="S/T">S/T</option>
        <option value="DTH">DTH</option>
        <option value="TV/F">TV/F</option>
        <option value="JIO">JIO</option>
        <option value="Others">OTHERS</option>
      </select>
    ) : (
      <h6 className="text-center text-success">
        Connection will be activated
      </h6>
    )}
  </b>
</div>


        {/* FOOTER */}
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSaveChanges}
          >
            Save changes
          </button>
        </div>

      </div>
    </div>
  </div>
)}

        <div className="">
          <div className="border-0 px-1">
            <form method="get" onSubmit={handleSubmit}>
              <div className="row mx-3">
                <div className="col-lg-3 col-md-6 col-12">
                  <div className="form-group">
                    <label htmlFor="choose" className="text-center text-navy valuesDec" style={{ borderRadius: "50px" }}>Choose</label>
                    <select className="form-control bg-gradient-navy  text-light border-0 elevation-3" id="choose" name="choose" value={formData.choose} onChange={handleChange} >
                      <option className='bg-light' value="">all</option>
                      <option className='bg-light' value="paid">Paid</option>
                      <option className='bg-light' value="extra paid">Advance Paid</option>
                      <option className='bg-light' value="unpaid">Unpaid</option>
                      <option className='bg-light' value="free">Free</option>
                      <option className='bg-light' value="pending">C. Pending</option>
                      <option className='bg-light' value="active">Active</option>
                      <option className='bg-light' value="deactive">Deactive</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="area_code" className="text-center valuesDec text-navy">Staff Code</label>
                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="area_code" name="area_code" value={formData.area_code} onChange={handleChange}>
                      <option className='bg-light' value="">none</option>
                      {staffCode.length > 0 ? (
                        staffCode.map((row, index) => (
                          <option className='bg-light' key={index} value={row.name + "-" + row.staffCode}>
                            {row.name} - {row.staffCode}
                          </option>
                        ))
                      ) : (
                        <option className='bg-light' value="">No staff codes available</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="street" className="text-center valuesDec text-navy">Street Name</label>
                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="street" name="street" value={formData.street} onChange={handleChange}>
                      <option className='bg-light' value="">none</option>
                      {streetName.length > 0 ? (
                        streetName.map((row, index) => (
                          <option className='bg-light' key={index} value={row.street_name}>
                            {row.street_name}
                          </option>
                        ))
                      ) : (
                        <option className='bg-light' value="">No staff codes available</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="flat" className="text-center valuesDec text-navy">Flat Name</label>
                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="flat" name="flat" value={formData.flat} onChange={handleChange}>
                      <option className='bg-light' value="">none</option>
                      {flatName.length > 0 ? (
                        flatName.map((row, index) => (
                          <option className='bg-light' key={index} value={row.flat_name}>
                            {row.flat_name}
                          </option>
                        ))
                      ) : (
                        <option className='bg-light' value="">No staff codes available</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="network" className="text-center valuesDec text-navy">Network Name</label>
                    <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="network" name="network" value={formData.network} onChange={handleChange}>
                      <option className='bg-light' value="">none</option>
                      {networkName.length > 0 ? (
                        networkName.map((row, index) => (
                          <option className='bg-light' key={index} value={row.network}>
                            {row.network}
                          </option>
                        ))
                      ) : (
                        <option className='bg-light' value="">No staff codes available</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="date" className="text-center valuesDec text-navy">Date</label>
                    <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} style={{ color: "white" }} />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-12 mb-2">
                  <div className="form-group">
                    <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                    <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                  </div>
                </div>
                <div className="col-lg-2 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                  <input type="submit" className="btn border-0 h-75 bg-success filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                </div>
                <div className="col-lg-1 col-md-3 mt-md-2 pt-2 pt-md-4 col-6 mb-2 d-flex justify-content-center">
                  <button type="button" className="btn border-0 bg-danger filterBtn text-light h-75 pb-3 pb-lg-1 w-100" onClick={handleClear}>Clear</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="d-flex justify-content-lg-start justify-content-center mx-lg-5 mb-3">
          <div className="mb-3 mx-2">
            <p className='pb-0 my-0 px-1'>Total Select Count - {selectedCustomers.length}</p>
            <button className="btn btn-md bg-gradient-navy elevation-3 my-0" onClick={handleMultiSelect} disabled={selectedCustomers.length === 0}> <i className="far fa-folder-open"></i> Multi Select Payment</button>

          </div>
          <div className="mt-3 pt-2 mx-2">
            <Link className='btn btn-danger' to={'/RecyclePage'}>
              <i className="far fa-trash-alt" /> Recycle
            </Link>
          </div>
        </div>
        <div className="card mt-3 mt-lg-3" style={{ backgroundColor: "rgb(186, 186, 186)" }}>
          <div className="card-header pb-0 py-lg-2 ">
            <div className="row">
              <div className="col-lg-4">
                <form>
                  <div className="input-group mt-1">
                    <input type="search"
                      className="form-control text-navy bg-light border-dark px-1 py-0"
                      placeholder="Search Name,STB,Code,Mobile,Package"
                      style={{ borderRadius: "5px 0 0 5px" }}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} />
                    <button type="submit" onClick={handleSearchSubmit} className="input-group-text bg-gradient-navy text-light border-0 px-3" style={{ borderRadius: "0 5px 5px 0", cursor: "pointer" }}> Go </button>
                  </div>
                </form>
              </div>
              <div className="col-lg-8 mt-lg-1 my-1">
                <span>
                  <div className="d-flex justify-content-lg-end justify-content-center">

                    <div className="btn-group">
                      <button onClick={downloadCSV} className="btn btn-dark border-right px-lg-3"> <i className="fas fa-download" /> Download </button>
                      <button
                        type="button"
                        className="btn btn-dark border-left px-lg-3" onClick={handleCopyToClipboard}>
                        <i className="far fa-copy" /> STBCOPY-{stbCount}
                      </button>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div className="card-body p-0 bg-light">
           <table
  id="myTable"
  className="table table-bordered table-dark table-responsive"
>

              <thead className="bg-gradient-navy">
                <tr>
                  <th>Sno</th>
                  <th>Status</th>
                  <th>Edit </th>
                  <th><input type="checkbox" onChange={handleSelectAll} /></th>
                  <th>Payment</th>
                  <th >Customer__Name</th>
                 
                  <th>Acc_no</th>
                  <th>Code</th>
                  <th>STB_no</th>
                  <th>Door_no</th>
                  <th>Flat_name</th>
                  <th className='text-center px-5'>Street__name</th>
                  <th>Phone</th>
                  <th>Pay Status</th>
                  <th>Plan Amount</th>
                  <th>Paid Amount</th>
                  <th className='text-center px-3'>Paid_Date</th>
                  <th>Balance Amount</th>
                  <th>Discount Amount</th>
                  <th>Advance Amount</th>
                  <th>Pending Amount</th>
                  <th>Staff__Code</th>
                  <th className='text-center px-5'>Network</th>
                  <th>Paid_time</th>
                  <th>&nbsp; __Package__ &nbsp;</th>
                  <th>Added_date</th>
                  {user === "srcv1" && (
                    <>
                      <th>Payment Mode</th>
                      <th>Chequee Number/Remarks</th>
                      <th>Payment For</th>
                    </>
                  )}

                  <th>Location</th>
                  <th>Collection Staff</th>
                  <th>Remove</th>
                </tr>
              </thead>
            <tbody className="text-dark">
  {currentRows.length > 0 ? (
    <>
      {currentRows.map((row, index) => {
        const isUnpaid = row.status === "unpaid" || row.status === "pending";
        const showCheckbox =
          row.balance_amt && Number(row.balance_amt) > 0;

        return (
          <tr
            key={row.id}
            style={{
              backgroundColor: isUnpaid
                ? "hsl(0,0%,96.9%)"
                : "rgba(214,252,228,0.7)",
            }}
          >
            {/* Serial */}
            <td className="tableText">{indexOfFirstRow + index + 1}</td>

            {/* Connection Status */}
            <td className="tableText">
              {["active", "Active"].includes(row.con_status) ? (
                <div className="d-flex-column">
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      handleConStatus(row.con_status, row.id, row.name)
                    }
                  >
                    A
                  </button>
                  {getConnectionLabel(row.con_type)}
                </div>
              ) : ["deactive", "Deactive"].includes(row.con_status) ? (
                <div className="d-flex-column">
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      handleConStatus(row.con_status, row.id, row.name)
                    }
                  >
                    D
                  </button>
                  {row.deactive_reason}/{row.dactive_date}
                </div>
              ) : (
                <div className="d-flex-column">
                  <button className="btn btn-secondary">
                    {row.con_status}
                  </button>
                  {row.deactive_reason}
                </div>
              )}
            </td>

            {/* Edit */}
            <td onClick={!isStaff ? () => EditClick(row.id) : undefined}>
  <div className="d-flex justify-content-center">
    <i
      className={`fas fa-edit h5 mt-3 pt-1 ${
        isStaff ? "text-muted" : "text-navy"
      }`}
    ></i>
  </div>
</td>

            {/* Checkbox */}
            <td className="py-lg-4">
              {showCheckbox && (
                <input
                  type="checkbox"
                  className="custom-checkbox form-control elevation-2"
                  checked={selectedCustomers.includes(row.id)}
                  onChange={() => handleCheckboxChange(row.id)}
                />
              )}
            </td>

            {/* Pay button */}
            <td className="tableText py-lg-3">
              {isUnpaid ? (
                <button
                  onClick={() => navigate(`/paymentPage/${row.id}`)}
                  className="btn btn-info elevation-2"
                >
                  Pay
                </button>
              ) : (
                <b className="text-danger">paid</b>
              )}
            </td>

            {/* Customer info */}
            <td
              className="text-bold tableText name"
              onClick={() => handleClick(row.acc_num)}
            >
              {row.name}
            </td>
            <td className="tableText">{row.account_num}</td>
            <td className="text-bold tableText">{row.acc_num}</td>
            <td className="text-bold tableText">{row.serial_num}</td>
            <td className="tableText">{row.doorno}</td>
            <td className="tableText">{row.flat_name}</td>
            <td className="text-bold tableText">{row.street}</td>
            <td className="text-bold tableText">{row.mobile}</td>

            {/* Payment fields */}
            <td className="text-bold tableText">{row.status}</td>
            <td className="text-bold tableText">{row.pay_amt}</td>
            <td className="text-bold tableText">{row.paid_amt}</td>
            <td className="text-bold tableText">{row.paid_date}</td>
            <td className="text-bold tableText">{row.balance_amt}</td>
            <td className="text-bold tableText">{row.discount}</td>
            <td className="text-bold tableText">
              {row.extra_balance_amt}
            </td>
            <td className="text-bold tableText">{row.pend_amt}</td>

            {/* Extra info */}
            <td className="text-bold tableText">{row.area_code}</td>
            <td className="text-bold tableText">{row.net_name}</td>
            <td className="text-bold tableText">{row.paid_time}</td>
            <td className="tableText">{row.package}</td>
            <td className="tableText">{row.adate}</td>

            {/* SRCV1 extra columns */}
            {user === "srcv1" && (
              <>
                <td className="tableText">{row.payment_mode}</td>
                <td className="tableText">{row.cheque_no}</td>
                <td className="tableText">{row.payment_for}</td>
              </>
            )}

            {/* Location */}
            <td className="tableText">
              <button className="btn btn-primary">
                <i className="fas fa-location-arrow" />
              </button>
            </td>

            {/* Collector */}
            <td className="tableText">{row.col_boy}</td>

            {/* Delete */}
            <td className="tableText py-lg-3">
              {isUnpaid ? (
                <button
                  onClick={() => handleDelete(row.id)}
                  className="btn btn-danger elevation-2"
                >
                  <i className="fas fa-trash" />
                </button>
              ) : (
                <b className="text-danger">paid</b>
              )}
            </td>
          </tr>
        );
      })}

      {/* ================= TOTAL ROW ================= */}
      <tr className="fw-bold"style={{
              backgroundColor:"rgba(250, 250, 250, 0.7)",
            }}>
        <td className="tableText border-dark text-bold text-bold">Total :</td>

    {/* Empty columns until Pay Amount column */}
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>
    <td className="tableText border-dark text-bold"></td>


        {/* Empty cols before totals */}
        {Array(9).fill(<td className="tableText border-dark"></td>)}

        <td className="tableText border-dark">{totalPayAmt}</td>
        <td className="tableText border-dark">{totalPaidAmt}</td>

        <td className="tableText border-dark"></td>
        <td className="tableText border-dark">{totalBalanceAmt}</td>
        <td className="tableText border-dark">{totalDiscountAmt}</td>
        <td className="tableText border-dark">{totalAdvanceAmt}</td>
        <td className="tableText border-dark">{totalPendingAmt}</td>

        {user === "srcv1" && Array(3).fill(<td className="tableText border-dark"></td>)}

        {Array(3).fill(<td className="tableText border-dark"></td>)}
      </tr>
    </>
  ) : (
    <tr>
      <td colSpan="30" className="text-center">
        No results found
      </td>
    </tr>
  )}
</tbody>

            </table>
          </div>
          <div className="card-footer">
            <div className="d-flex justify-content-end">
              <div className="pagination btn-group border-light">
                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                {currentPage > 3 && <span className="mx-1">...</span>}
                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                  .filter((page) => page > 1 && page < totalPages)
                  .map((page) => (
                    <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                  ))}
                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                {totalPages > 1 && (
                  <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                )}
                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
              </div>
            </div>
          </div>
        </div>

      </div></div>
    </div>
  );
}
export default AllCustomer;
